import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Typography, withStyles} from '@material-ui/core'

import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import FormElement from '../../components/FormElement/FormElement'
import FormElementType from '../../components/FormElement/FormElementType'
import {PageContainer, SubmitButton} from '../../components/components'
import {bindActionCreators} from 'redux'
import {projectActions, metaActions} from '../../core/actions'
import {titlePrefix} from '../../index'
import {validations} from '../../util/validations'

const styles = {
    container: {
        flexDirection: 'column',
        transitionDuration: '1s'
    },

    title: {
        textAlign: 'center',
        fontSize: '2em',
        fontWeight: 300,
        paddingTop: '1em',
        paddingBottom: '1em'
    },

    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '5em',
        marginBottom: '5em',
        alignSelf: 'center'
    }
}

const mapStateToProps = state => ({
    isUploading: state.project.isUploading,
    isFetchingMetas: state.meta.isFetchingMetas,
    user: state.auth.user,
    metas: state.meta.metas,
    error: state.project.error
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...projectActions, ...metaActions}, dispatch)
})

class Uploader extends Component {
    state = {
        files: [],
        isDisabled: true
    }

    componentDidMount () {
        document.title = `${titlePrefix}Create Project`
        this.props.getMetas()
    }

    formFieldsInputs = []

    formFields = () => {
        const metas = metaActions.util.formatToMetaOptions(this.props.metas)
        return [
            {label: 'Project Name', name: 'name', minLength: 3, maxLength: 50, type: 'text', required: true},
            {label: 'Authors', name: 'authors', minLength: 3, maxLength: 50, type: 'text', required: true},
            {label: 'Project Description', name: 'description', minLength: 10, maxLength: 500, type: 'text', required: true, multiline: true},
            {label: 'Package Name', name: 'packageName', minLength: 6, maxLength: 25, type: 'text', required: true},
            {label: 'Price', name: 'price', minLength: 0, maxLength: 25, type: 'number'},
            {label: 'Project Categories', name: 'categories', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.categories, multiple: true},
            {label: 'Project User Interface', name: 'interfaces', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.interfaces, multiple: true},
            {label: 'Project OS Support', name: 'platforms', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.platforms, multiple: true},
            {label: 'Project Coded Languages', name: 'languages', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.languages, multiple: true},
            {label: 'Project\'s Framework Dependencies', name: 'frameworks', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.frameworks, multiple: true},
            {label: 'Project Visibility', name: 'listed', elementType: FormElementType.Radio, options: {1: 'Public', 0: 'Unlisted'}},
            {label: 'Version Number', name: 'version', minLength: 1, maxLength: 50, type: 'text', required: true, validations: validations.downloadable.versionNumber},
            {label: 'Drag & Drop your <span class="filepond--label-action">Release files </span> or <span class="filepond--label-action"> Browse </span>', name: 'release', required: false, elementType: FormElementType.MultiFile, filePondProps: {allowMultiple: true, maxFiles: 20, dropValidation: true}},
            {label: 'Drag & Drop your <span class="filepond--label-action">Source files </span> or <span class="filepond--label-action"> Browse </span>', name: 'source', required: false, elementType: FormElementType.MultiFile, filePondProps: {allowMultiple: true, maxFiles: 20, dropValidation: true}},
            {label: <Fragment>Drag & Drop your <span className="filepond--label-action">Cover Image/Icon </span> or <span className="filepond--label-action"> Browse </span></Fragment>, required: true, name: 'coverImage', elementType: FormElementType.ImageDropper, imagePreviewSize: 'iconLarge'},
            {label: <Fragment>Drag & Drop your <span className="filepond--label-action">Screenshots </span> or <span className="filepond--label-action"> Browse </span></Fragment>, name: 'screenshots[]', required: true, elementType: FormElementType.ImageDropper, multiple: true, hasCaption: true}
        ]
    }

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.formFieldsInputs).find(key => {
            if (this.formFieldsInputs[key].props.elementType === FormElementType.ImageDropper && this.formFieldsInputs[key].state.isValid && this.formFieldsInputs[key].props.hasCaption) {
                return !this.formFieldsInputs[key].state.innerDataIsValid
            }
            return !this.formFieldsInputs[key].state.isValid
        }) !== undefined
        this.setState({isDisabled})
    }

    onSubmit = () => {
        let formData = new FormData();
        Object.keys(this.formFieldsInputs).forEach(key => {
            if (this.formFieldsInputs[key].props.elementType === FormElementType.Select && this.formFieldsInputs[key].props.multiple) {
                this.formFieldsInputs[key].state.value.forEach((item, index) => {
                    formData.append(`${key}[${index}]`, item)
                })
            } else if (this.formFieldsInputs[key].props.elementType === FormElementType.MultiFile) {
                this.formFieldsInputs[key].state.value.forEach(file => {
                    formData.append(key, file)
                })
            } else if (this.formFieldsInputs[key].props.elementType === FormElementType.ImageDropper) {
                if (this.formFieldsInputs[key].props.multiple) {
                    this.formFieldsInputs[key].state.value.forEach(file => {
                        if (this.formFieldsInputs[key].props.hasCaption) {
                            const inputs = this.formFieldsInputs[key].imageDropper.captions[file.name].formFieldsInputs
                            formData.append(`captions[${file.name}][caption1]`, inputs.caption1.state.value)
                            formData.append(`captions[${file.name}][caption2]`, inputs.caption2.state.value)
                        }
                        formData.append(key, file)
                    })
                } else formData.append(key, this.formFieldsInputs[key].state.value[0])
            } else formData.append(key, this.formFieldsInputs[key].state.value)
        })
        this.props.createProject(formData)
    }

    render() {
        const {classes: styles, isUploading, user} = this.props
        if (!user) return <Redirect to={'/'} />

        return (
            <PageContainer gridProps={{xl: 6}} className={styles.container}>
                <Typography variant="h6" color="inherit" className={styles.title}>
                        Project Uploader
                </Typography>

                {this.formFields().map((props, index) => (
                    <FormElement key={index} {...props} innerRef={ref => (this.formFieldsInputs[props.name] = ref)} onValidationChangeDetected={this.onValidationChangeDetected} />
                ))}

                <SubmitButton className={styles.submitButton} isDisabled={this.state.isDisabled} isProcessing={isUploading} onClick={this.onSubmit} loadingText={'Uploading..'}>Submit</SubmitButton>
            </PageContainer>
        );
    }

}

Uploader.propTypes = {
    classes: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Uploader));
